import { useState } from 'react'

export const useAttachmentFiles = () => {
  const [files, setFiles] = useState([])
  const [loadedFiles, setLoadedFiles] = useState([])

  const getFiles = files => setFiles(files)

  const removeFile = name => {
    const removeIndexFile = files.map(file => file.name).indexOf(name)
    const removeIndexLoadedFile = loadedFiles
      .map(file => file.name)
      .indexOf(name)
    const newArrayFiles = [...files]
    const newArrayLoadedFiles = [...loadedFiles]

    newArrayFiles.splice(removeIndexFile, 1)
    newArrayLoadedFiles.splice(removeIndexLoadedFile, 1)
    setFiles(newArrayFiles)
    setLoadedFiles(newArrayLoadedFiles)
  }

  const updateLoadedFiles = updatedFile => {
    const updateIndexFile = loadedFiles
      .map(file => file.name)
      .indexOf(updatedFile.name)
    const newArrayLoadedFiles = [...loadedFiles]

    if (updateIndexFile === -1) {
      newArrayLoadedFiles.push(updatedFile)
    } else {
      newArrayLoadedFiles.splice(updateIndexFile, 1, updatedFile)
    }

    setLoadedFiles(newArrayLoadedFiles)
  }

  const resetLoadedFiles = () => setLoadedFiles([])

  return {
    files,
    getFiles,
    removeFile,
    loadedFiles,
    resetLoadedFiles,
    updateLoadedFiles,
  }
}
